module.exports = __webpack_public_path__ + "static/media/1POLICY32.ad76ac7b.jpg";